import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Overlay from "../../components/overlay";
import { tripSpeedChart } from "../../store/Slices/TripSlice";
import "../../styles/Trip.css";
import SpinnerLoader from "../../utils/SpinnerLoader";
import TripTracker from "./TripTracker";

/* ---------------- DATE NAV ICONS ---------------- */
const chevronLeftIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M15 18L9 12L15 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const chevronRightIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M9 18L15 12L9 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const fuelData = [
  90, 89, 87, 85, 83, 81, 78, 75, 72, 68, 64, 60, 57, 54, 50, 47, 44, 41, 38,
  35, 32, 30, 28, 25,
];

const rpmData = [
  2, 4, 5, 6, 7, 4, 4, 8, 6, 1, 3, 1, 2, 4, 1, 3, 6, 8, 5, 4, 5, 1, 4, 2,
];

const TripHistoryTimeline = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { tripSpeedChartData, speedChartLoading, tripDetailsData } = useSelector((state) => state.trips);

  const [selectedDate, setSelectedDate] = useState(tripDetailsData?.actual_start_at ? dayjs(tripDetailsData?.actual_start_at) : dayjs());

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const dateString = selectedDate ? selectedDate.format("YYYY-MM-DD") : "";

  useEffect(() => {
    if (id && dateString) {
      dispatch(tripSpeedChart({ trip_id: id, date: dateString }));
    }
  }, [id, dateString]);

  /* ---------------- CHART DATA ---------------- */
  const speedData = tripSpeedChartData?.map((item) => item.speed) || [];

  const hours = tripSpeedChartData?.map((item) => {
    return item.recorded_at ? dayjs(item.recorded_at).format("HH:mm") : "";
  }) || [];

  const baseOptions = {
    chart: {
      toolbar: { show: false },
      zoom: { enabled: false },
      foreColor: "#98A2B3",
      fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial",
      parentHeightOffset: 0,
    },

    stroke: { curve: "smooth", width: 2.8 },
    markers: { size: 0 },
    dataLabels: { enabled: false },
    legend: { show: false },

    grid: {
      borderColor: "#EAECF0",
      strokeDashArray: 4,
      padding: {
        left: 0,
        right: 12,
        top: 6,
        bottom: 0,
      },
    },

    xaxis: {
      categories: hours,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        style: { colors: "#98A2B3", fontSize: "12px" },
        offsetY: 2,
      },
      tooltip: { enabled: false },
    },

    yaxis: {
      min: 0,
      axisBorder: { show: false },
      axisTicks: { show: false },

      labels: {
        style: { colors: "#98A2B3", fontSize: "12px" },
        offsetX: -10,
      },

      title: {
        rotate: -90,
        offsetX: -6,
        offsetY: 0,
        style: {
          color: "#98A2B3",
          fontSize: "12px",
          fontWeight: 400,
        },
      },
    },

    tooltip: { theme: "light" },
  };

  return (
    <div>
      <div className="history_card">
        <div className="history_card_header">
          <div>
            <h4>Pre Inspection Questionnaire</h4>
            <p>Main information for this trip record.</p>
          </div>
        </div>

        <div className="history_timeline_title">
          <h5>Trip Checkpoint Timeline</h5>

          {/* <div className="history_date_switcher">
          <button
            type="button"
            aria-label="Previous day"
            className="history_date_btn"
            onClick={() => setSelectedDate(selectedDate.subtract(1, 'day'))}
          >
            {chevronLeftIcon}
          </button>

          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            format="YYYY - DD - MMMM"
            allowClear={false}
            suffixIcon={null}
            style={{
              border: 'none',
              background: 'transparent',
              boxShadow: 'none',
              fontWeight: '600',
              fontSize: '16px',
              color: '#3d3f5c',
              padding: '0px',
              textAlign: 'center',
              width: '140px',
              cursor: 'pointer',
            }}
            inputReadOnly
          />

          <button
            type="button"
            aria-label="Next day"
            className="history_date_btn"
            onClick={() => setSelectedDate(selectedDate.add(1, 'day'))}
          >
            {chevronRightIcon}
          </button>
        </div> */}
        </div>

        <TripTracker />


        {/* =================== SPEED GRAPH (with right date switcher like screenshot) =================== */}
        <div className="history_chart_header">
          <h5>Speed Graph</h5>

          <div className="history_date_switcher">
            <button
              type="button"
              aria-label="Previous day"
              className="history_date_btn"
              onClick={() => setSelectedDate(selectedDate.subtract(1, 'day'))}
            >
              {chevronLeftIcon}
            </button>

            <DatePicker
              value={selectedDate}
              onChange={handleDateChange}
              format="YYYY - DD - MMMM"
              allowClear={false}
              suffixIcon={null}
              style={{
                border: 'none',
                background: 'transparent',
                boxShadow: 'none',
                fontWeight: '600',
                fontSize: '16px',
                color: '#3d3f5c',
                padding: '0px',
                textAlign: 'center',
                width: '140px',
                cursor: 'pointer !important',
              }}
              inputReadOnly
            />

            <button
              type="button"
              aria-label="Next day"
              className="history_date_btn"
              onClick={() => setSelectedDate(selectedDate.add(1, 'day'))}
            >
              {chevronRightIcon}
            </button>
          </div>
        </div>

        {
          speedChartLoading ? <SpinnerLoader /> :
            <div style={{ overflowX: "auto", overflowY: "hidden", paddingBottom: "10px" }}>
              <div style={{ minWidth: `${Math.max(100, (speedData.length || 0) * 30)}px` }}>
                <ReactApexChart
                  type="line"
                  height={320}
                  series={[{ name: "Speed", data: speedData }]}
                  options={{
                    ...baseOptions,
                    colors: ["#4F6BED"],
                    yaxis: {
                      ...baseOptions.yaxis,
                      max: 200,
                      tickAmount: 4,
                      title: { ...baseOptions.yaxis.title, text: "Speed (km/h)" },
                    },
                  }}
                />
              </div>
            </div>
        }

        <div style={{ position: "relative" }}>
          <Overlay />

          <div>
            {/* =================== FUEL TREND =================== */}
            <div className="history_chart_header">
              <h5>Fuel Trend</h5>
            </div>

            <ReactApexChart
              type="line"
              height={320}
              series={[{ name: "Fuel", data: fuelData }]}
              options={{
                ...baseOptions,
                colors: ["#F59E0B"],
                yaxis: {
                  ...baseOptions.yaxis,
                  min: 20,
                  max: 90,
                  tickAmount: 7,
                  labels: {
                    ...baseOptions.yaxis.labels,
                    formatter: (val) => {
                      const v = Math.round(val);
                      return v % 10 === 0 ? `${v}` : "";
                    },
                  },
                  title: { ...baseOptions.yaxis.title, text: "Fuel (Ltrs.)" },
                },
              }}
            />

            {/* =================== RPM GRAPH =================== */}
            <div className="history_chart_header">
              <h5>RPM Graph</h5>
            </div>

            <ReactApexChart
              type="line"
              height={320}
              series={[{ name: "RPM", data: rpmData }]}
              options={{
                ...baseOptions,
                colors: ["#4C1D95"],
                yaxis: {
                  ...baseOptions.yaxis,
                  max: 10,
                  tickAmount: 5,
                  title: { ...baseOptions.yaxis.title, text: "RPM (x1000)" },
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripHistoryTimeline;
